export default "__VITE_ASSET__D9Kd5nJS__"